import {Required} from "./required";
import {Email} from "./email";
import {PostalCode} from "./postalCode";
import {PhoneNumber} from "./phoneNumber";
import {MaxLength} from "./maxLength";
import {DateRange} from "./dateRange";
import {Optional} from "./optional";
import type {FormValidationConfig, Validation} from "./validations";
import {MaxUploadSize} from "./maxUploadSize";
import {SupportedFileTypes} from "./supportedFileTypes";
import {MinAge} from "./minAge";
import {PermittedValues} from "./permittedValues";
import {MaxUploads} from "./maxUploads";
import {MinCheckedOptions} from "./minCheckedOptions";
import {ValidDate} from "./validDate";

export namespace ValidationFactory {
    // eslint-disable-next-line complexity
    export function from(config: FormValidationConfig): Validation {
        switch (config.id) {
            case "required":
                return Required.from(config);
            case "dateRange":
                return DateRange.from(config);
            case "validDate":
                return ValidDate.from(config);
            case "minAge":
                return MinAge.from(config);
            case "email":
                return Email.from(config);
            case "postalCode":
                return PostalCode.from(config);
            case "phoneNumber":
                return PhoneNumber.from(config);
            case "maxLength":
                return MaxLength.from(config);
            case "maxUploadSize":
                return MaxUploadSize.from(config);
            case "maxUploads":
                return MaxUploads.from(config);
            case "supportedFileTypes":
                return SupportedFileTypes.from(config);
            case "permittedValues":
                return PermittedValues.from(config);
            case "minCheckedOptions":
                return MinCheckedOptions.from(config);
            default:
                return new Optional();
        }
    }
}
